import { capitalCase } from 'capital-case';
import React from 'react';
import Avatar from 'src/components/10-atoms/avatar/Avatar';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import useI18n from 'src/modules/translations/hooks/useI18n';
import useCurrentUserProfile from 'src/modules/user/hooks/useCurrentUserProfile';
import SidebarItem from './SidebarItem';
const ProfileSidebarItem = ({ focused }) => {
    const { translate } = useI18n();
    const [{ data: profile }] = useCurrentUserProfile();
    const label = profile
        ? capitalCase(profile.details.firstName || profile.details.lastName || translate('Profile'))
        : translate('Profile');
    return (React.createElement(SidebarItem, { prefix: "User_", label: label, to: { screen: 'User_Home', params: {} }, focused: focused, renderIcon: (color, size) => profile ? (React.createElement(Avatar, { size: "xxs", uri: profile.details.avatarURL })) : (React.createElement(FeatherIcon, { name: "user", color: color, size: size })) }));
};
export default ProfileSidebarItem;
